import api from './apiClient';

export const fetchFromPickupShimpents = async (payload?: any) => {
  const response = await api.post('/shipments/table', payload);
  return response.data;
};
